import { isValidUrl } from '../../../../common/utils';

export const isValidImpactedWorkUrl = (url: string): boolean => isValidUrl(url);
